import { CommonResponse, returnException } from '@boi/backend-utils';
import { Body, Controller, Post } from '@nestjs/common';
import { ModelPaperService } from './model-paper.service';
import { ClassQnpMRequestModel, ClassRequestModel, CreatePaperModelReq, SubjectClassReqModel } from '@boi/shared-models';

@Controller('model-paper')
export class ModelPaperController {
  constructor(private readonly modelPaperService: ModelPaperService) { }

  @Post('createModelPaper')
  async createModelPaper(@Body() createPaperModelReq: CreatePaperModelReq): Promise<CommonResponse> {
    try {
      return await this.modelPaperService.createModelPaper(createPaperModelReq);
    } catch (error) {
      return returnException(CommonResponse, error);
    }
  }

  @Post('getModelPaperDataBySubject')
  async getModelPaperDataBySubject(@Body() req: SubjectClassReqModel): Promise<CommonResponse> {
    try {
      return await this.modelPaperService.getModelPaperDataBySubject(req)
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }

  @Post('getAllModelPaperData')
  async getAllModelPaperData(@Body() req: ClassRequestModel): Promise<CommonResponse> {
    try {
      return await this.modelPaperService.getAllModelPaperData(req)
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }

  @Post('getModelPaperData')
  async getModelPaperData(@Body() req: ClassQnpMRequestModel): Promise<CommonResponse> {
    try {
      return await this.modelPaperService.getModelPaperData(req)
    } catch (error) {
      return returnException(CommonResponse, error)
    }
  }
}
